import { hasValue } from 'swipeclock-frontend';
import {
  clearAllOfflineWebClockDataForChannelSwitch,
  clearOfflineWebClockData,
  PENDING_OFFLINE_CLEAR_ALL,
} from './offlineWebClockStorage';

/**
 * Confirms offline WebClock secure-storage cleanup for session end paths
 * (logout, token invalidation, lifecycle auth failure).
 *
 * When no userKey is available, performs a bulk clear and returns
 * {@link PENDING_OFFLINE_CLEAR_ALL} as the pending marker key.
 *
 * @param {string | null | undefined} userKey
 * @returns {Promise<{ cleared: boolean, pendingKey: string }>}
 */
export const confirmOfflineWebClockCleanup = async (userKey) => {
  const pendingKey = hasValue(userKey) ? userKey : PENDING_OFFLINE_CLEAR_ALL;

  try {
    if (hasValue(userKey)) {
      return {
        cleared: Boolean(await clearOfflineWebClockData(userKey)),
        pendingKey,
      };
    }

    return {
      cleared: Boolean(await clearAllOfflineWebClockDataForChannelSwitch()),
      pendingKey,
    };
  } catch (error) {
    console.warn('[WebClock] Offline WebClock cleanup failed.', error);
    return { cleared: false, pendingKey };
  }
};
